module.exports = "<div class=\"card-avatar\">\n  <h2 class=\"name\">\n    <employee-name name=\"{{$ctrl.employee.name}}\" enrollment=\"{{$ctrl.employee.userId}}\"></employee-name>\n  </h2>\n  <avatar-app ng-if=\"$ctrl.employee !== undefined\"\n              size-big\n              name=\"$ctrl.employee.name\"\n              email=\"$ctrl.employee.email\"\n              user-id=\"$ctrl.employee.userId\"></avatar-app>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/food-benefit.module/components/userCardList/userCardRow/homeCard/cardAvatar/cardAvatar.html
// module id = 1622
// module chunks = 0